/**
 * Created by DejanK on 10/8/2016.
 *
 */
import angular from 'angular';

import './rb-textarea.scss';

export default {
  template: '<textarea></textarea>',
  require: {
    ngModel: '?ngModel'
  },
  bindings: {
    maxRows: '<',
    placeholder: '@'
  },
  controller: Ctrl
};

Ctrl.$inject = ['$element', '$timeout'];
function Ctrl($element, $timeout){
  const vm = this, textareaElement = angular.element($element.find('textarea')[0]);
  let maxRows = 5;


  this.$onInit = ()=>{
    textareaElement[0].rows = 1;

    textareaElement.on('input change', ()=>{
      autoGrow();
      vm.ngModel.$setViewValue(textareaElement[0].value);
    });

    vm.ngModel.$render = ()=>{
      textareaElement[0].value = angular.isUndefined(vm.ngModel.$viewValue) ? '' : vm.ngModel.$viewValue;
    };

    autoGrow();
  };

  this.$onChanges = (changes)=>{
    if(changes.maxRows && vm.maxRows) updateMaxRows();
    if(changes.placeholder && vm.placeholder) updatePlaceholder();

    function updateMaxRows(){
      maxRows = vm.maxRows;
      autoGrow();
    }

    function updatePlaceholder(){
      textareaElement.attr('placeholder', vm.placeholder);
    }
  };

  function autoGrow(){
    $timeout(()=>{
      const textareaHtmlElement = textareaElement[0];
      while(textareaHtmlElement.scrollTop > 0){
        if(textareaHtmlElement.rows < maxRows) {
          textareaHtmlElement.rows++;
        } else {
          textareaHtmlElement.rows = maxRows;
          textareaElement.css('overflow', 'auto');
          break;
        }
      }
    })
  }
}

